import { IDrawStyle } from "../songView/abstraction/IDrawStyle";
import { IPoint, ISize } from "./Geometry";

export function drawWithStyle(ctx: CanvasRenderingContext2D, style: IDrawStyle) {

    ctx.globalAlpha = style.opacity ?? 1;

    if (style.fillColor) {

        ctx.fillStyle = style.fillColor;
        ctx.fill();
    }

    if (style.strokeColor && style.strokeWidth) {
        ctx.lineWidth = style.strokeWidth;
        ctx.strokeStyle = style.strokeColor;
        ctx.stroke();
    }
}

export function drawRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number) {

    ctx.moveTo(x, y);
    ctx.lineTo(x + width, y);
    ctx.lineTo(x + width, y + height);
    ctx.lineTo(x, y + height);
    ctx.lineTo(x, y);
}

export function clipMargins(ctx: CanvasRenderingContext2D, margin: IPoint, viewSize: ISize) {

    const curTrans = ctx.getTransform();

    ctx.resetTransform();

    ctx.beginPath();
    ctx.rect(0, 0, margin.x, viewSize.height);
    ctx.rect(0, 0, viewSize.width, margin.y);

    //ctx.clip();
    



    ctx.setTransform(curTrans);
}